export const TRACKING_LEVEL_DESCRIPTIONS = new Map([
  [1, 'This shipment must track using either the Transfix App or a 3rd party integration'],
  [2, 'This shipment needs location tracking, but exception can be made without severe penalty.'],
  [3, 'This shipment requires frequent updates which can be satisfied by app tracking.'],
  [4, 'This shipment does not need tracking.'],
])
